// QBO Vendors — accounting review surface for payee<->QBO vendor drift.
// Lists linked payees whose Atticus + QuickBooks data have diverged; opens the payee modal
// (QBO panel) to review the field-by-field diff and authorize the sync. (LD-QBO-VENDOR-001)
import { useState, useEffect } from "react";
import { apiFetch, can } from "../api";
import PayeeProfileModal from "./PayeeProfileModal";

const FIELD_LABEL = { display_name: "Name on check", legal_name: "Tax entity", remit_address_line1: "Address",
  remit_city: "City", remit_state: "State", remit_zip: "Zip", reportable_1099: "1099", tin_last4: "TIN" };

export default function QboVendorDrift() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const [modal, setModal] = useState(null);
  const canManage = can("manage_payees");

  const load = () => { setRows(null); setErr(null);
    apiFetch("/payees/qbo-drift").then(d => setRows(d.drift || [])).catch(e => setErr(String(e.message || e))); };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <h3 style={{ margin: 0, fontSize: 15 }}>QBO Vendors — out of sync</h3>
        <button className="btn btn-sm btn-outline" onClick={load}>Refresh</button>
        <span style={{ fontSize: 12, color: "var(--text3)" }}>Payees linked to a QuickBooks vendor whose data has diverged. Review to pull or push each field.</span>
      </div>
      {err && <div style={{ color: "#991b1b", fontSize: 12 }}>{err}</div>}
      {rows === null && !err && <div style={{ fontSize: 13, color: "var(--text3)" }}>Checking QuickBooks…</div>}
      {rows && rows.length === 0 && <div style={{ fontSize: 13, color: "#166534" }}>All linked vendors are in sync ✓</div>}
      {rows && rows.length > 0 && (
        <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
          <thead><tr style={{ textAlign: "left", color: "var(--text3)", fontSize: 11 }}>
            <th style={{ padding: "4px 8px" }}>QuickBooks vendor</th>
            <th style={{ padding: "4px 8px" }}>Linked payee</th>
            <th style={{ padding: "4px 8px" }}>Diverged fields</th>
            <th style={{ padding: "4px 8px" }}></th>
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} style={{ borderTop: "1px solid var(--border)" }}>
                <td style={{ padding: "6px 8px", fontWeight: 600 }}>{r.vendor_name || `Vendor ${r.qbo_vendor_id}`}</td>
                <td style={{ padding: "6px 8px", color: "var(--text2)" }}>{r.entity_kind} #{r.entity_id}</td>
                <td style={{ padding: "6px 8px" }}>{(r.diff_fields || []).map(f => (
                  <span key={f} style={{ display: "inline-block", background: "#fef3c7", color: "#92400e", borderRadius: 4, padding: "1px 6px", fontSize: 11, marginRight: 4, marginBottom: 2 }}>{FIELD_LABEL[f] || f}</span>
                ))}</td>
                <td style={{ padding: "6px 8px", textAlign: "right" }}>
                  {canManage && <button className="btn btn-sm btn-blue" onClick={() => setModal({ kind: r.entity_kind, entityId: r.entity_id, name: r.vendor_name })}>Review &amp; sync</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {modal && <PayeeProfileModal kind={modal.kind} entityId={modal.entityId} name={modal.name} onClose={() => { setModal(null); load(); }} />}
    </div>
  );
}
